import React from 'react';

function UserMessage(props) {
    const { value } = props && props;
    return (
        <div className={`messengerCt__wrapper`}>
            <div className="messengerCt__message messengerCt__message--out">
                <div className="messengerCt__message-body">
                    <div className="messengerCt__message-content --arrow-right">
                        <div className="messengerCt__message-text whiteSpace-break" dangerouslySetInnerHTML={{ __html: value }} />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default UserMessage;